var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common-container" }, [
    _c(
      "div",
      { staticClass: "search-container" },
      [
        _c("span", { staticClass: "title-h4" }, [
          _vm._v(_vm._s(_vm.$t("portContacts.portContacts"))),
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "search-form",
            attrs: { model: _vm.form, "label-width": "120px" },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 30 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 14 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("portContacts.company"),
                          prop: "company",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { filterable: "", clearable: "" },
                            on: { change: _vm.toSearch },
                            model: {
                              value: _vm.form.deptId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "deptId", $$v)
                              },
                              expression: "form.deptId",
                            },
                          },
                          _vm._l(_vm.companyList, function (item) {
                            return _c("el-option", {
                              key: item.deptId,
                              attrs: {
                                label: _vm.isCnLang
                                  ? item.officeName
                                  : item.officeNameEn,
                                value: item.deptId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "result-container" },
      [
        _vm._l(_vm.contactData, function (item) {
          return _c("div", [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(
                _vm._s(_vm.isCnLang ? item.officeName : item.officeNameEn)
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-left": "60px",
                  "margin-top": "10px",
                  "white-space": "pre-line",
                },
              },
              [
                _c(
                  "span",
                  [
                    _c("mavon-editor", {
                      staticClass: "md",
                      staticStyle: {
                        "padding-top": "0px",
                        "padding-bottom": "0px",
                      },
                      attrs: {
                        value: item.content,
                        subfield: false,
                        toolbarsFlag: false,
                        editable: false,
                        boxShadow: false,
                        toolbars: _vm.markdownOption,
                        language: _vm.$t("global.language"),
                        fontSize: "16px",
                        defaultOpen: "preview",
                        previewBackground: "#ffffff",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ])
        }),
        _vm._v(" "),
        !_vm.validateNull(_vm.contactData) && _vm.hqID !== _vm.form.deptId
          ? _c("div", [
              _c("div", [
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("portContacts.complaintCenter"))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "60px",
                    "margin-top": "10px",
                    "white-space": "pre-line",
                  },
                },
                [
                  _c(
                    "span",
                    [
                      _c("mavon-editor", {
                        staticClass: "md",
                        staticStyle: {
                          "padding-top": "0px",
                          "padding-bottom": "0px",
                        },
                        attrs: {
                          value: this.hqContact[0].content,
                          subfield: false,
                          toolbarsFlag: false,
                          editable: false,
                          boxShadow: false,
                          toolbars: _vm.markdownOption,
                          language: _vm.$t("global.language"),
                          fontSize: "16px",
                          defaultOpen: "preview",
                          previewBackground: "#ffffff",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }